<template>
    <div>
        <div class="list-campaign"
            v-if="isLoaded && isHaveItem">
            <campaign-item
                v-for="(campaign, k) in campaigns"
                :key="k"
                :index="k"
                :campaign="campaign"
                :mainType="mainType"
            ></campaign-item>
        </div>
        <div class="nolist-campaign"
            v-if="!isHaveItem">
            <img src="../../../assets/icon/icon_no_data.png">
            <div class="text-empty">{{lbl.reward.reward_empty}}</div>
        </div>
        <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
</template>
<script>
import Vue from "vue";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//component
import CampaignItem from "./CampaignItem.vue";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";

export default {
    name: "CampaignList",
    mixins: [
        AccountMixin,
        LocaleMixin,
        ErrorApiMixin
    ],
    components: {
        CampaignItem,
        ModalMaster
    },
    props: {
        userType: String,
        //isLoading: Boolean,
        mainType: String,
        initListConfig: Object,
        initFilterConfig: Object,
        busEvent: Object,
    },
    data: function() {
        return {
            campaigns: [],

            isLoaded: false,
            isLoading: false,
            isHaveItem: false,
            listConfig: {},
            filterConfig: {},

            busModal: new Vue(),
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            loadingModal: new LoadingModalController(),

            canLoadMore: true,
            isListLoading: false,
        };
    },
    created: function() {
        //config
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;
        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setLoadingModal(this.loadingModal);
        //error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);
    },
    mounted: function() {
        this.getList();
        this.busEvent.$on("switchLang", this.switchLang);
        this.busEvent.$on("reInitList", this.reInitialList);
    },
    beforeDestroy: function () {
        window.onscroll = function(){};
    },
    methods: {
        //initial
        initialLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.getList();
                }
            };
        },
        //event
        //method
        getList: function() {
            if (!this.listConfig.strConfigList) return;
            if (!this.canLoadMore) return;
            if (this.isListLoading) return;

            //var token = Account.getToken();
            this.isListLoading = true;

            if (this.showLoading()) return;
            var strBzbsToken = this.getToken();
            var defaultTopAmount = this.listConfig.defaultTopAmount;
            BzbsCampaign.apiGetCampaign(strBzbsToken, this.listConfig, this.filterConfig)
                .then(campaigns => {
                    this.listConfig.intSkip += defaultTopAmount;

                    //check is there are more campaign.
                    if (campaigns.length < defaultTopAmount) {
                        this.canLoadMore = false;
                        this.listConfig.isSeeMoreEnable = false;
                    }


                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip ==
                        defaultTopAmount)
                        this.campaigns = [];

                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaigns.push(campaign);
                    }

                    this.isListLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.campaigns.length > 0
                        ? true
                        : false;

                    this.$nextTick(() => {
                        this.initialLoadMore();
                    });

                    this.hideLoading();
                }).catch(err => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.isListLoading = false;
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        resetLoaded: function () {
            this.campaigns = [];
            this.isListLoading = false;
            this.canLoadMore =  true;
            this.isLoaded = false;
            this.isHaveItem = false;
        },
        reInitialList: function (data) {
            this.resetLoaded();
            this.listConfig = data.listConfig;
            this.filterConfig = data.filterConfig;

            this.getList();
        },
        //loading
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.loadingModal.hide();
        }
    }
};
</script>
<style lang="scss" scoped>
@import "./campaignlist.scss";
</style>
